module.exports = __webpack_public_path__ + "static/media/correctivostickets-06-rojo.923cdae3.svg";